export function normalizeSearchValue(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function slugifyDirectoryValue(value = "") {
  return normalizeSearchValue(value).replace(/\s+/g, "-");
}

export function buildSearchText(record) {
  return normalizeSearchValue(
    Object.values(record)
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .filter((value) => typeof value === "string" || typeof value === "number")
      .join(" "),
  );
}

export function uniqueSorted(values = []) {
  return [...new Set(values.filter(Boolean))].sort((a, b) =>
    String(a).localeCompare(String(b)),
  );
}

export function paginate(items, page = 1, pageSize = 12) {
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(Math.max(Number(page) || 1, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return {
    page: safePage,
    totalPages,
    items: items.slice(start, start + pageSize),
  };
}

export function formatVerificationDate(value) {
  if (!value) return "Verification date unavailable";
  const date = new Date(`${value}T00:00:00Z`);
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
}

export function externalLinkProps() {
  return { target: "_blank", rel: "noopener noreferrer" };
}

// Match the two editorial datasets without dropping a company merely because
// a similar brand name or a common source publisher appears in both.
export function sameDirectoryCompany(primary, secondary) {
  const names = (record) => [record.name, ...(record.aliases || [])]
    .flatMap((name) => [name, ...String(name || "").split(" / ")])
    .map(normalizeSearchValue).filter(Boolean);
  const secondaryNames = new Set(names(secondary));
  if (names(primary).some((name) => secondaryNames.has(name))) return true;
  const host = (value) => {
    try { return new URL(value).hostname.toLowerCase().replace(/^www\d*\./, ""); }
    catch { return ""; }
  };
  const primaryHost = host(primary.website || primary.officialUrl);
  const secondaryHost = host(secondary.website || secondary.officialUrl);
  return Boolean(primaryHost && secondaryHost && primaryHost === secondaryHost);
}
